module.exports = __webpack_public_path__ + "static/media/log_2.334d1f32.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/manual/log_2.jpg
// module id = 1891
// module chunks = 0